import Page from '@/features/Services/pages/Privacy'

export default Page
